import { render, staticRenderFns } from "./ForgotPwd.vue?vue&type=template&id=9e11c1c0&scoped=true&"
import script from "./ForgotPwd.vue?vue&type=script&lang=js&"
export * from "./ForgotPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPwd.vue?vue&type=style&index=0&id=9e11c1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e11c1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
